import { render, staticRenderFns } from "./SupplierDocForm.vue?vue&type=template&id=7a4bcaa5&scoped=true&"
import script from "./SupplierDocForm.vue?vue&type=script&lang=js&"
export * from "./SupplierDocForm.vue?vue&type=script&lang=js&"
import style0 from "./SupplierDocForm.vue?vue&type=style&index=0&id=7a4bcaa5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4bcaa5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a4bcaa5')) {
      api.createRecord('7a4bcaa5', component.options)
    } else {
      api.reload('7a4bcaa5', component.options)
    }
    module.hot.accept("./SupplierDocForm.vue?vue&type=template&id=7a4bcaa5&scoped=true&", function () {
      api.rerender('7a4bcaa5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/detailPages/supplierDetailPages/SupplierDocForm.vue"
export default component.exports